(function () {
  // Read what your selector already writes
  var STORAGE_KEY_PHONE = 'selectedModel';               // e.g. "iphone-16-pro-max"
  var STORAGE_KEY_HEADPHONES = 'selectedHeadphonesModel';// if you later need it
  var METAFIELD_INPUT_NAME = 'filter.p.m.custom.model_name'; // <-- change namespace if needed

  function getActiveStorageKey() {
    // If you need to branch by page, do it here. For now, phones:
    return STORAGE_KEY_PHONE;
  }

  function getStoredModel() {
    var key = getActiveStorageKey();
    var val = localStorage.getItem(key);
    if (!val || /\s/.test(val)) return null; // ignore empty/spacey values (matches your selector logic)
    return val;
  }

  function ensureHidden(name, form) {
    var input = form.querySelector('input[name="'+ name +'"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    return input;
  }

  function setHiddenFilterInput(form, model) {
    if (!model) return;
    // force product-only search
    ensureHidden('type', form).value = 'product';
    // set metafield filter value
    ensureHidden(METAFIELD_INPUT_NAME, form).value = model;
  }

  function patchAllSearchForms(model) {
    var forms = document.querySelectorAll('form[action="/search"], form[action*="/search?"]');
    forms.forEach(function (form) {
      setHiddenFilterInput(form, model);
      form.addEventListener('submit', function () {
        setHiddenFilterInput(form, model);
      }, { passive: true });
    });
  }

  function interceptSearchLinks(model) {
    var links = document.querySelectorAll('a[href^="/search"]');
    links.forEach(function (a) {
      try {
        var url = new URL(a.getAttribute('href'), window.location.origin);
        if (model && !url.searchParams.has(METAFIELD_INPUT_NAME)) {
          url.searchParams.set('type', 'product');
          url.searchParams.set(METAFIELD_INPUT_NAME, model);
          a.setAttribute('href', url.pathname + url.search);
        }
      } catch(e) {}
    });
  }

  // Optional: if user lands on /search without the filter but we have a model, add it & reload
  function enforceOnSearchPage(model) {
    if (!model) return;
    if (location.pathname === '/search') {
      var url = new URL(location.href);
      if (!url.searchParams.has(METAFIELD_INPUT_NAME)) {
        url.searchParams.set('type', 'product');
        url.searchParams.set(METAFIELD_INPUT_NAME, model);
        location.replace(url.pathname + url.search);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var model = getStoredModel();
    if (!model) return; // no selection yet → show all models

    patchAllSearchForms(model);
    interceptSearchLinks(model);
    enforceOnSearchPage(model);
  });
})();